module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable47.be4f51dd.jpg";